/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';
import type { Interpolation } from '@emotion/react';

import * as React from 'react';

import { breakpoints } from '@coursera/cds-core';
import type { Theme } from '@coursera/cds-core';

import { EntWebsiteDomainContext } from 'bundles/ent-website/components/EntWebsiteDomainContext';
import { EntWebsiteNavDomainContext } from 'bundles/ent-website/components/EntWebsiteNavDomainContext';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import EntWebsitePageHeader from 'bundles/ent-website/components/EntWebsitePageHeader';
import FootnoteList from 'bundles/ent-website/components/FootnoteList';
import { getMetaHeight } from 'bundles/ent-website/components/MetaNavigation';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import PageAssembly from 'bundles/ent-website/contentful/pages/PageAssembly';
import PageFooter from 'bundles/page-footer/components/PageFooter';

type Props = {
  slug: string;
};

export const NAV_BREAKPOINT = 1200;
export const MENU_HEIGHT = '100px';
export const MENU_HEIGHT_MOBILE = '56px';

const EntWebsitePage = ({ slug }: Props) => {
  const { domain } = React.useContext(EntWebsiteDomainContext);
  const { forceHideMetaNav } = React.useContext(EntWebsiteNavDomainContext);

  const styles: Record<string, Interpolation<Theme>> = {
    headerOffset: () => css`
      padding-top: calc(
        ${MENU_HEIGHT} +
          ${getMetaHeight({
            domain,
            forceOverride: !forceHideMetaNav,
          })}
      );
      ${breakpoints.down(NAV_BREAKPOINT)} {
        padding-top: calc(${MENU_HEIGHT_MOBILE});
      }
    `,
    scrollingWrapper: () => css`
      ${breakpoints.down(NAV_BREAKPOINT)} {
        .hide-smart-scroll-container {
          top: 0 !important;
        }
      }
    `,
  };

  return (
    <>
      <div css={styles.scrollingWrapper}>
        <EntWebsitePageHeader hasAuthentication={false} />
      </div>
      <main css={styles.headerOffset} className="rc-EntWebsitePage">
        <PageAssembly slug={slug} domain={domain} />
      </main>
      <PageFooter isDirectoryPage />
      <FootnoteList />
    </>
  );
};

export default EntWebsitePage;
